import script from "./GerenciarRelatorios.vue?vue&type=script&setup=true&lang=js"
export * from "./GerenciarRelatorios.vue?vue&type=script&setup=true&lang=js"

import "./GerenciarRelatorios.vue?vue&type=style&index=0&id=20d4cbb7&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d4cbb7"]])

export default __exports__